import { Component, OnInit, Input } from '@angular/core';

export interface Section {
  name: string;
  updated: Date;
}


@Component({
  selector: 'app-document-type',
  templateUrl: './document-type.component.html',
  styleUrls: ['./document-type.component.scss']
})
export class DocumentTypeComponent implements OnInit {

  @Input() documents: DocumentType[];
  @Input() titlle: String;


  constructor() {  }

  ngOnInit() {
  }

}
